import React, { useState } from "react";
import { toast } from "react-toastify";

export default function AdminNewsletter() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [pdf, setPdf] = useState(null);
  const [loading, setLoading] = useState(false);

  async function sendNewsletter() {
  if (!subject.trim() || !message.trim()) {
    return toast.error("Veuillez remplir tous les champs !");
  }

  const token = localStorage.getItem("membreToken");

  if (!token) {
    toast.error("Non autorisé.");
    return;
  }

  setLoading(true);

  try {
    const formData = new FormData();
    formData.append("subject", subject);
    formData.append("message", message);

    if (pdf) {
      formData.append("pdf", pdf);
    }

    const res = await fetch("/api/sendNewsletter", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token
      },
      body: formData
    });

    if (res.status === 403) {
      localStorage.removeItem("membreToken");
      toast.error("Accès refusé.");
      setLoading(false);
      return;
    }

    const data = await res.json();
    setLoading(false);

    if (data.success) {
      toast.success("Newsletter envoyée avec succès !");
      setSubject("");
      setMessage("");
      setPdf(null);
    } else {
      toast.error(data.error || "Erreur lors de l’envoi.");
    }

  } catch (err) {
    setLoading(false);
    toast.error("Impossible de contacter le serveur.");
    console.error(err);
  }
}


  return (
    <div className="p-4 max-w-2xl mx-auto space-y-6">

      <h1 className="text-2xl font-bold dark:text-white text-center">
        ✉️ Envoyer une Newsletter
      </h1>

      
      <input
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        placeholder="Sujet de votre email"
        className="w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white dark:border-gray-700"
      />

      
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows="10"
        placeholder="Écrivez le contenu de votre newsletter..."
        className="w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white dark:border-gray-700"
      />

      
      <input
        type="file"
        accept="application/pdf"
        onChange={(e) => setPdf(e.target.files[0])}
        className="w-full text-sm dark:text-white"
      />

      {pdf && (
        <p className="text-sm text-green-600 dark:text-green-400">
          📎 PDF sélectionné : {pdf.name}
        </p>
      )}

      
      {message.trim() !== "" && (
        <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded shadow border dark:border-gray-700">
          <h3 className="font-semibold mb-2 dark:text-white">Aperçu :</h3>
          <div
            className="prose dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      )}

      
      <button
        onClick={sendNewsletter}
        disabled={loading}
        className={`w-full py-3 rounded-lg text-white font-bold transition 
          ${loading ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}
        `}
      >
        {loading ? "⏳ Envoi en cours..." : "🚀 Envoyer la newsletter"}
      </button>
    </div>
  );
}
